import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

export const OpenIQPersona2InactiveIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 48 48">
    <circle cx="24" cy="24" r="24" fill="#DBD9D8" />
    <path
      d="M33.4076 5.3102C39.741 8.96696 41.9969 16.9725 38.5832 23.3771L38.5908 23.3815L30.6626 37.1136L30.655 37.1092C26.8153 43.2681 18.7536 45.3167 12.42 41.6599C6.08648 38.0032 3.83047 29.9977 7.24437 23.5931L7.23676 23.5887L15.165 9.85658L15.1726 9.86098C19.0123 3.70222 27.074 1.65352 33.4076 5.3102Z"
      fill="#636669"
    />
    <path
      d="M36.5527 33C39.7259 33 42.8064 33.4022 45.75 34.1543C41.9251 42.333 33.6252 48 24 48C18.9409 48 14.2489 46.4325 10.3789 43.7598C17.1535 37.0998 26.3811 33 36.5527 33Z"
      fill="#636669"
    />
    <path
      d="M26.6191 15.7666V20.1689H27.6582C27.8906 18.7434 29.1279 17.6553 30.6191 17.6553C31.5916 17.6553 32.4538 18.1197 33.002 18.8369C33.3878 19.3417 33.6191 19.9709 33.6191 20.6553C33.6191 21.3407 33.3868 21.9704 33 22.4756V22.4795C32.6122 22.9837 32.0671 23.3608 31.4385 23.5391L33 26.2432V37.6553C33 39.3121 30.3137 40.6553 27 40.6553C23.6863 40.6553 21 39.3121 21 37.6553V32C17.6863 32 15 29.1594 15 25.6553V17.6553C15 15.9517 15.4726 14.3582 16.2949 13L26.6191 15.7666Z"
      fill="#B6B5B4"
    />
    <path d="M21 32H29L21 38V32Z" fill="#636669" />
  </SvgIcon>
);
